/** CoStar.Api.AptsListings.ViewModels.ActivityType */
export var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["Unknown"] = 0] = "Unknown";
    ActivityType[ActivityType["Search"] = 1] = "Search";
    ActivityType[ActivityType["PlacardView"] = 2] = "PlacardView";
    ActivityType[ActivityType["DetailView"] = 3] = "DetailView";
})(ActivityType || (ActivityType = {}));
/** @deprecated Deprecated in version 1.11.0. */
import { UserPortal } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsListings.ViewModels.UserPortal */
export { UserPortal };
import { SchoolLevels } from "../../../../CoStar/Api/AptsContentSub/ViewModels/index.js";
/** CoStar.Api.AptsListings.ViewModels.SchoolLevels */
export { SchoolLevels };
import { SchoolGrades } from "../../../../CoStar/Api/AptsContentSub/ViewModels/index.js";
/** CoStar.Api.AptsListings.ViewModels.SchoolGrades */
export { SchoolGrades };
/** CoStar.Api.AptsListings.ViewModels.ProsumerLevel */
export var ProsumerLevel;
(function (ProsumerLevel) {
    ProsumerLevel[ProsumerLevel["None"] = 0] = "None";
    ProsumerLevel[ProsumerLevel["Unverified"] = 1] = "Unverified";
    ProsumerLevel[ProsumerLevel["Verified"] = 2] = "Verified";
})(ProsumerLevel || (ProsumerLevel = {}));
/** CoStar.Api.AptsListings.ViewModels.AddressValidationResponseType */
export var AddressValidationResponseType;
(function (AddressValidationResponseType) {
    AddressValidationResponseType[AddressValidationResponseType["Unknown"] = 0] = "Unknown";
    AddressValidationResponseType[AddressValidationResponseType["Validated"] = 1] = "Validated";
    AddressValidationResponseType[AddressValidationResponseType["PartiallyValidated"] = 2] = "PartiallyValidated";
    AddressValidationResponseType[AddressValidationResponseType["NotValidated"] = 3] = "NotValidated";
})(AddressValidationResponseType || (AddressValidationResponseType = {}));
/** CoStar.Api.AptsListings.ViewModels.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["Submarket"] = 5] = "Submarket";
    GeographyFilterType[GeographyFilterType["Street"] = 6] = "Street";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
    GeographyFilterType[GeographyFilterType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyFilterType[GeographyFilterType["Country"] = 15] = "Country";
    GeographyFilterType[GeographyFilterType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyFilterType[GeographyFilterType["Region"] = 17] = "Region";
    GeographyFilterType[GeographyFilterType["CBSA"] = 18] = "CBSA";
    GeographyFilterType[GeographyFilterType["CSA"] = 19] = "CSA";
    GeographyFilterType[GeographyFilterType["DMA"] = 20] = "DMA";
    GeographyFilterType[GeographyFilterType["Cluster"] = 21] = "Cluster";
    GeographyFilterType[GeographyFilterType["Airport"] = 22] = "Airport";
    GeographyFilterType[GeographyFilterType["HotelName"] = 23] = "HotelName";
    GeographyFilterType[GeographyFilterType["TransitStation"] = 24] = "TransitStation";
    GeographyFilterType[GeographyFilterType["Military"] = 25] = "Military";
    GeographyFilterType[GeographyFilterType["University"] = 26] = "University";
    GeographyFilterType[GeographyFilterType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    GeographyFilterType[GeographyFilterType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    GeographyFilterType[GeographyFilterType["SchoolDistrict"] = 39] = "SchoolDistrict";
    GeographyFilterType[GeographyFilterType["CityAggregate"] = 40] = "CityAggregate";
})(GeographyFilterType || (GeographyFilterType = {}));
/** CoStar.Api.AptsListings.ViewModels.ContactRoleType */
export var ContactRoleType;
(function (ContactRoleType) {
    ContactRoleType[ContactRoleType["Developer_Construction"] = 1] = "Developer_Construction";
    ContactRoleType[ContactRoleType["Architect"] = 2] = "Architect";
    ContactRoleType[ContactRoleType["RecordedOwner"] = 3] = "RecordedOwner";
    ContactRoleType[ContactRoleType["PropertyManager"] = 4] = "PropertyManager";
    ContactRoleType[ContactRoleType["PrimaryLeasingCo_Landlord"] = 6] = "PrimaryLeasingCo_Landlord";
    ContactRoleType[ContactRoleType["TrueOwner"] = 7] = "TrueOwner";
    ContactRoleType[ContactRoleType["SignAgent"] = 8] = "SignAgent";
    ContactRoleType[ContactRoleType["AssetorPortfolioManager"] = 9] = "AssetorPortfolioManager";
    ContactRoleType[ContactRoleType["BuyerBroker"] = 10] = "BuyerBroker";
    ContactRoleType[ContactRoleType["ListingBroker"] = 11] = "ListingBroker";
    ContactRoleType[ContactRoleType["TenantRep"] = 15] = "TenantRep";
    ContactRoleType[ContactRoleType["DecisionMaker_Leasing"] = 17] = "DecisionMaker_Leasing";
    ContactRoleType[ContactRoleType["DecisionInfluencer_Leasing"] = 18] = "DecisionInfluencer_Leasing";
    ContactRoleType[ContactRoleType["LeasingCompany"] = 20] = "LeasingCompany";
    ContactRoleType[ContactRoleType["Principal"] = 26] = "Principal";
    ContactRoleType[ContactRoleType["SurveyContact"] = 27] = "SurveyContact";
    ContactRoleType[ContactRoleType["CenterMailContact"] = 28] = "CenterMailContact";
    ContactRoleType[ContactRoleType["CenterManager"] = 29] = "CenterManager";
    ContactRoleType[ContactRoleType["Asst_AssocCenterManager"] = 30] = "Asst_AssocCenterManager";
    ContactRoleType[ContactRoleType["Marketing"] = 31] = "Marketing";
    ContactRoleType[ContactRoleType["SpecialtyLeasingManager"] = 32] = "SpecialtyLeasingManager";
    ContactRoleType[ContactRoleType["BuildingSuperintendent"] = 33] = "BuildingSuperintendent";
    ContactRoleType[ContactRoleType["SecuritySupervisor"] = 34] = "SecuritySupervisor";
    ContactRoleType[ContactRoleType["AdvertisingManager"] = 35] = "AdvertisingManager";
    ContactRoleType[ContactRoleType["SpecialEventsManager"] = 36] = "SpecialEventsManager";
    ContactRoleType[ContactRoleType["PromotionDirector_Manager"] = 37] = "PromotionDirector_Manager";
    ContactRoleType[ContactRoleType["Other"] = 38] = "Other";
    ContactRoleType[ContactRoleType["RecordedSeller"] = 39] = "RecordedSeller";
    ContactRoleType[ContactRoleType["TrueSeller"] = 40] = "TrueSeller";
    ContactRoleType[ContactRoleType["Attorney"] = 41] = "Attorney";
    ContactRoleType[ContactRoleType["RecordedBuyer"] = 42] = "RecordedBuyer";
    ContactRoleType[ContactRoleType["TrueBuyer"] = 43] = "TrueBuyer";
    ContactRoleType[ContactRoleType["BuyerContact"] = 44] = "BuyerContact";
    ContactRoleType[ContactRoleType["SellerContact"] = 45] = "SellerContact";
    ContactRoleType[ContactRoleType["ListingAgent"] = 46] = "ListingAgent";
    ContactRoleType[ContactRoleType["LeasingAgent"] = 47] = "LeasingAgent";
    ContactRoleType[ContactRoleType["TenantContact"] = 48] = "TenantContact";
    ContactRoleType[ContactRoleType["Preparer"] = 49] = "Preparer";
    ContactRoleType[ContactRoleType["ListingAdministrator"] = 50] = "ListingAdministrator";
    ContactRoleType[ContactRoleType["SurveillanceOperator"] = 51] = "SurveillanceOperator";
    ContactRoleType[ContactRoleType["OwnerListingContact"] = 52] = "OwnerListingContact";
    ContactRoleType[ContactRoleType["WSRListingAdministrator"] = 53] = "WSRListingAdministrator";
    ContactRoleType[ContactRoleType["SocialAdminSetupContact"] = 54] = "SocialAdminSetupContact";
    ContactRoleType[ContactRoleType["OwnerListingAdministrator"] = 55] = "OwnerListingAdministrator";
    ContactRoleType[ContactRoleType["OwnerPermissionAdministrator"] = 56] = "OwnerPermissionAdministrator";
    ContactRoleType[ContactRoleType["ListingPermissionAdministrator"] = 57] = "ListingPermissionAdministrator";
    ContactRoleType[ContactRoleType["HotelMembershipCompany"] = 58] = "HotelMembershipCompany";
    ContactRoleType[ContactRoleType["Acquisitions_Dispositions"] = 59] = "Acquisitions_Dispositions";
    ContactRoleType[ContactRoleType["Leasing"] = 62] = "Leasing";
    ContactRoleType[ContactRoleType["Finance"] = 63] = "Finance";
    ContactRoleType[ContactRoleType["InvestorRelations"] = 64] = "InvestorRelations";
    ContactRoleType[ContactRoleType["Research"] = 66] = "Research";
    ContactRoleType[ContactRoleType["HR_Legal_IT_and_Operations"] = 67] = "HR_Legal_IT_and_Operations";
    ContactRoleType[ContactRoleType["DecisionMaker_Acquisitions"] = 68] = "DecisionMaker_Acquisitions";
    ContactRoleType[ContactRoleType["DecisionInfluencer_Acquisitions"] = 69] = "DecisionInfluencer_Acquisitions";
    ContactRoleType[ContactRoleType["DecisionMaker_ProductPurchase"] = 70] = "DecisionMaker_ProductPurchase";
    ContactRoleType[ContactRoleType["DecisionInfluencer_ProductPurchase"] = 71] = "DecisionInfluencer_ProductPurchase";
    ContactRoleType[ContactRoleType["Servicer"] = 72] = "Servicer";
    ContactRoleType[ContactRoleType["Borrower"] = 73] = "Borrower";
    ContactRoleType[ContactRoleType["SpecialServicer"] = 74] = "SpecialServicer";
    ContactRoleType[ContactRoleType["Originator"] = 75] = "Originator";
    ContactRoleType[ContactRoleType["Sponsor"] = 76] = "Sponsor";
    ContactRoleType[ContactRoleType["HotelOperator"] = 77] = "HotelOperator";
    ContactRoleType[ContactRoleType["Auctioneer"] = 78] = "Auctioneer";
    ContactRoleType[ContactRoleType["AuctionManager"] = 79] = "AuctionManager";
    ContactRoleType[ContactRoleType["GeneralContractor"] = 80] = "GeneralContractor";
    ContactRoleType[ContactRoleType["TitleCompany"] = 81] = "TitleCompany";
    ContactRoleType[ContactRoleType["EscrowCompany"] = 82] = "EscrowCompany";
    ContactRoleType[ContactRoleType["AuctionAssetManager"] = 83] = "AuctionAssetManager";
    ContactRoleType[ContactRoleType["ReportVendor"] = 84] = "ReportVendor";
    ContactRoleType[ContactRoleType["FundManager"] = 85] = "FundManager";
    ContactRoleType[ContactRoleType["LawFirm"] = 86] = "LawFirm";
    ContactRoleType[ContactRoleType["Auditor"] = 87] = "Auditor";
    ContactRoleType[ContactRoleType["FundPlacementAgent"] = 88] = "FundPlacementAgent";
    ContactRoleType[ContactRoleType["FundAdministrator"] = 89] = "FundAdministrator";
    ContactRoleType[ContactRoleType["Investor"] = 90] = "Investor";
    ContactRoleType[ContactRoleType["MediaSchedulingContact"] = 91] = "MediaSchedulingContact";
    ContactRoleType[ContactRoleType["SubletContact"] = 1000] = "SubletContact";
    ContactRoleType[ContactRoleType["PreviousTrueOwner"] = 1001] = "PreviousTrueOwner";
    ContactRoleType[ContactRoleType["PreviousRecordedOwner"] = 1002] = "PreviousRecordedOwner";
    ContactRoleType[ContactRoleType["ExecutiveLeadership_Principal"] = 1003] = "ExecutiveLeadership_Principal";
    ContactRoleType[ContactRoleType["LeaseCompsAdministrator"] = 1004] = "LeaseCompsAdministrator";
    ContactRoleType[ContactRoleType["FeedContact"] = 1005] = "FeedContact";
    ContactRoleType[ContactRoleType["ConstructionCompany"] = 1006] = "ConstructionCompany";
    ContactRoleType[ContactRoleType["PromotingOwner"] = 1007] = "PromotingOwner";
    ContactRoleType[ContactRoleType["ContractContact"] = 1008] = "ContractContact";
})(ContactRoleType || (ContactRoleType = {}));
/** CoStar.Api.AptsListings.ViewModels.DynamicLeadFormType */
export var DynamicLeadFormType;
(function (DynamicLeadFormType) {
    DynamicLeadFormType[DynamicLeadFormType["None"] = 0] = "None";
    DynamicLeadFormType[DynamicLeadFormType["ListingId"] = 1] = "ListingId";
    DynamicLeadFormType[DynamicLeadFormType["PmcId"] = 2] = "PmcId";
})(DynamicLeadFormType || (DynamicLeadFormType = {}));
/** CoStar.Api.AptsListings.ViewModels.CollegeAssignmentType */
export var CollegeAssignmentType;
(function (CollegeAssignmentType) {
    CollegeAssignmentType[CollegeAssignmentType["Unknown"] = 0] = "Unknown";
    CollegeAssignmentType[CollegeAssignmentType["OnCampus"] = 1] = "OnCampus";
    CollegeAssignmentType[CollegeAssignmentType["OffCampus"] = 2] = "OffCampus";
    CollegeAssignmentType[CollegeAssignmentType["Preferred"] = 3] = "Preferred";
})(CollegeAssignmentType || (CollegeAssignmentType = {}));
import { SchoolType } from "../../../../CoStar/Api/AptsContentSub/ViewModels/index.js";
/** CoStar.Api.AptsListings.ViewModels.SchoolType */
export { SchoolType };
import { ListingPhoneType } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsListings.ViewModels.ListingPhoneType */
export { ListingPhoneType };
/** CoStar.Api.AptsListings.ViewModels.PetType */
export var PetType;
(function (PetType) {
    PetType[PetType["Unknown"] = 0] = "Unknown";
    PetType[PetType["Bird"] = 1] = "Bird";
    PetType[PetType["Cat"] = 2] = "Cat";
    PetType[PetType["Dog"] = 3] = "Dog";
    PetType[PetType["Fish"] = 4] = "Fish";
    PetType[PetType["Reptile"] = 5] = "Reptile";
    PetType[PetType["Other"] = 6] = "Other";
})(PetType || (PetType = {}));
/** CoStar.Api.AptsListings.ViewModels.PetRequirements */
export var PetRequirements;
(function (PetRequirements) {
    PetRequirements[PetRequirements["None"] = 0] = "None";
    PetRequirements[PetRequirements["Declawed"] = 1] = "Declawed";
    PetRequirements[PetRequirements["Interview"] = 2] = "Interview";
    PetRequirements[PetRequirements["SpayedNeutered"] = 4] = "SpayedNeutered";
})(PetRequirements || (PetRequirements = {}));
/** CoStar.Api.AptsListings.ViewModels.ParkingType */
export var ParkingType;
(function (ParkingType) {
    ParkingType[ParkingType["Unknown"] = 0] = "Unknown";
    ParkingType[ParkingType["SurfaceLot"] = 1] = "SurfaceLot";
    ParkingType[ParkingType["GarageLot"] = 2] = "GarageLot";
    ParkingType[ParkingType["CoveredLot"] = 3] = "CoveredLot";
    ParkingType[ParkingType["Street"] = 4] = "Street";
    ParkingType[ParkingType["Garage"] = 5] = "Garage";
    ParkingType[ParkingType["Carport"] = 6] = "Carport";
    ParkingType[ParkingType["Other"] = 7] = "Other";
})(ParkingType || (ParkingType = {}));
/** CoStar.Api.AptsListings.ViewModels.ApartmentFeeType */
export var ApartmentFeeType;
(function (ApartmentFeeType) {
    ApartmentFeeType[ApartmentFeeType["Unknown"] = 0] = "Unknown";
    ApartmentFeeType[ApartmentFeeType["AmenityFee"] = 1] = "AmenityFee";
    ApartmentFeeType[ApartmentFeeType["AdministrationFee"] = 2] = "AdministrationFee";
    ApartmentFeeType[ApartmentFeeType["ApplicationFee"] = 3] = "ApplicationFee";
    ApartmentFeeType[ApartmentFeeType["MoveInFee"] = 4] = "MoveInFee";
    ApartmentFeeType[ApartmentFeeType["NoncashGift"] = 6] = "NoncashGift";
    ApartmentFeeType[ApartmentFeeType["Other"] = 7] = "Other";
    ApartmentFeeType[ApartmentFeeType["SatelliteFee"] = 9] = "SatelliteFee";
    ApartmentFeeType[ApartmentFeeType["StorageFee"] = 10] = "StorageFee";
    ApartmentFeeType[ApartmentFeeType["AdditionalSecurityDeposit"] = 11] = "AdditionalSecurityDeposit";
    ApartmentFeeType[ApartmentFeeType["AdditionalSecurityDepositRefundable"] = 12] = "AdditionalSecurityDepositRefundable";
    ApartmentFeeType[ApartmentFeeType["BrokerFee"] = 13] = "BrokerFee";
    ApartmentFeeType[ApartmentFeeType["LeasePreparation"] = 14] = "LeasePreparation";
    ApartmentFeeType[ApartmentFeeType["ResidentAccessKeysCardsLocksRemotesFee"] = 15] = "ResidentAccessKeysCardsLocksRemotesFee";
    ApartmentFeeType[ApartmentFeeType["SecurityDeposit"] = 16] = "SecurityDeposit";
    ApartmentFeeType[ApartmentFeeType["SecurityDepositRefundable"] = 17] = "SecurityDepositRefundable";
    ApartmentFeeType[ApartmentFeeType["TrashAdminFee"] = 18] = "TrashAdminFee";
    ApartmentFeeType[ApartmentFeeType["UtilityServiceFee"] = 19] = "UtilityServiceFee";
    ApartmentFeeType[ApartmentFeeType["UtilitySetUpFee"] = 20] = "UtilitySetUpFee";
    ApartmentFeeType[ApartmentFeeType["AdministrativeFee"] = 21] = "AdministrativeFee";
    ApartmentFeeType[ApartmentFeeType["Cable"] = 22] = "Cable";
    ApartmentFeeType[ApartmentFeeType["UtilitiesAndServiceFeesAmenityFee"] = 23] = "UtilitiesAndServiceFeesAmenityFee";
    ApartmentFeeType[ApartmentFeeType["CommunityFee"] = 24] = "CommunityFee";
    ApartmentFeeType[ApartmentFeeType["ConvenienceFee"] = 25] = "ConvenienceFee";
    ApartmentFeeType[ApartmentFeeType["HighSpeedInternetAccess"] = 26] = "HighSpeedInternetAccess";
    ApartmentFeeType[ApartmentFeeType["Hydro"] = 27] = "Hydro";
    ApartmentFeeType[ApartmentFeeType["LaundryRoom"] = 28] = "LaundryRoom";
    ApartmentFeeType[ApartmentFeeType["MaintenanceFee"] = 29] = "MaintenanceFee";
    ApartmentFeeType[ApartmentFeeType["PackageDelivery"] = 30] = "PackageDelivery";
    ApartmentFeeType[ApartmentFeeType["PackageLockers"] = 31] = "PackageLockers";
    ApartmentFeeType[ApartmentFeeType["PackageValet"] = 32] = "PackageValet";
    ApartmentFeeType[ApartmentFeeType["PestControl"] = 33] = "PestControl";
    ApartmentFeeType[ApartmentFeeType["RecyclingCharge"] = 34] = "RecyclingCharge";
    ApartmentFeeType[ApartmentFeeType["ResidentUtilityCharge"] = 35] = "ResidentUtilityCharge";
    ApartmentFeeType[ApartmentFeeType["TechnologyFee"] = 36] = "TechnologyFee";
    ApartmentFeeType[ApartmentFeeType["UtilityDrainage"] = 37] = "UtilityDrainage";
    ApartmentFeeType[ApartmentFeeType["UtilityElectric"] = 38] = "UtilityElectric";
    ApartmentFeeType[ApartmentFeeType["UtilityGas"] = 39] = "UtilityGas";
    ApartmentFeeType[ApartmentFeeType["UtilityStormwater"] = 40] = "UtilityStormwater";
    ApartmentFeeType[ApartmentFeeType["UtilityWasteWater"] = 41] = "UtilityWasteWater";
    ApartmentFeeType[ApartmentFeeType["UtilityWater"] = 42] = "UtilityWater";
    ApartmentFeeType[ApartmentFeeType["ValetTrash"] = 43] = "ValetTrash";
    ApartmentFeeType[ApartmentFeeType["WasherDryerRental"] = 44] = "WasherDryerRental";
    ApartmentFeeType[ApartmentFeeType["OtherFeesCable"] = 45] = "OtherFeesCable";
    ApartmentFeeType[ApartmentFeeType["CleaningCharges"] = 46] = "CleaningCharges";
    ApartmentFeeType[ApartmentFeeType["ConciergeService"] = 47] = "ConciergeService";
    ApartmentFeeType[ApartmentFeeType["OtherFeesHighSpeedInternetAccess"] = 48] = "OtherFeesHighSpeedInternetAccess";
    ApartmentFeeType[ApartmentFeeType["LiabilityInsurance"] = 49] = "LiabilityInsurance";
    ApartmentFeeType[ApartmentFeeType["RenterInsurance"] = 50] = "RenterInsurance";
    ApartmentFeeType[ApartmentFeeType["OtherFeesPackageDelivery"] = 51] = "OtherFeesPackageDelivery";
    ApartmentFeeType[ApartmentFeeType["OtherFeesPackageLockers"] = 52] = "OtherFeesPackageLockers";
    ApartmentFeeType[ApartmentFeeType["OtherFeesPackageValet"] = 53] = "OtherFeesPackageValet";
    ApartmentFeeType[ApartmentFeeType["AdditionalResidentAccessKeysCardsLocksRemotesFee"] = 54] = "AdditionalResidentAccessKeysCardsLocksRemotesFee";
    ApartmentFeeType[ApartmentFeeType["ReservationHoldingFee"] = 55] = "ReservationHoldingFee";
    ApartmentFeeType[ApartmentFeeType["MealService"] = 56] = "MealService";
})(ApartmentFeeType || (ApartmentFeeType = {}));
/** CoStar.Api.AptsListings.ViewModels.ListingAdLevel */
export var ListingAdLevel;
(function (ListingAdLevel) {
    ListingAdLevel[ListingAdLevel["None"] = 0] = "None";
    ListingAdLevel[ListingAdLevel["Premier"] = 1] = "Premier";
    ListingAdLevel[ListingAdLevel["Elite"] = 2] = "Elite";
    ListingAdLevel[ListingAdLevel["Platinum"] = 3] = "Platinum";
    ListingAdLevel[ListingAdLevel["Diamond"] = 4] = "Diamond";
    ListingAdLevel[ListingAdLevel["DiamondPlus"] = 5] = "DiamondPlus";
    ListingAdLevel[ListingAdLevel["Premium"] = 6] = "Premium";
    ListingAdLevel[ListingAdLevel["PremiumPlus"] = 7] = "PremiumPlus";
    ListingAdLevel[ListingAdLevel["PremiumMax"] = 8] = "PremiumMax";
})(ListingAdLevel || (ListingAdLevel = {}));
/** CoStar.Api.AptsListings.ViewModels.HousingSpecialties */
export var HousingSpecialties;
(function (HousingSpecialties) {
    HousingSpecialties[HousingSpecialties["None"] = 0] = "None";
    HousingSpecialties[HousingSpecialties["Senior"] = 1] = "Senior";
    HousingSpecialties[HousingSpecialties["Military"] = 2] = "Military";
    HousingSpecialties[HousingSpecialties["Student"] = 4] = "Student";
    HousingSpecialties[HousingSpecialties["Corporate"] = 8] = "Corporate";
    HousingSpecialties[HousingSpecialties["ShortTerm"] = 16] = "ShortTerm";
    HousingSpecialties[HousingSpecialties["IncomeRestricted"] = 32] = "IncomeRestricted";
})(HousingSpecialties || (HousingSpecialties = {}));
/** CoStar.Api.AptsListings.ViewModels.HousingSubSpecialties */
export var HousingSubSpecialties;
(function (HousingSubSpecialties) {
    HousingSubSpecialties[HousingSubSpecialties["None"] = 0] = "None";
    HousingSubSpecialties[HousingSubSpecialties["ActiveAdult"] = 1] = "ActiveAdult";
    HousingSubSpecialties[HousingSubSpecialties["IndependentLiving"] = 2] = "IndependentLiving";
    HousingSubSpecialties[HousingSubSpecialties["SeniorHousing"] = 4] = "SeniorHousing";
    HousingSubSpecialties[HousingSubSpecialties["StudentHousing"] = 8] = "StudentHousing";
    HousingSubSpecialties[HousingSubSpecialties["OffCampusHousing"] = 16] = "OffCampusHousing";
})(HousingSubSpecialties || (HousingSubSpecialties = {}));
/** CoStar.Api.AptsListings.ViewModels.ApartmentUtilityType */
export var ApartmentUtilityType;
(function (ApartmentUtilityType) {
    ApartmentUtilityType[ApartmentUtilityType["None"] = 0] = "None";
    ApartmentUtilityType[ApartmentUtilityType["Gas"] = 1] = "Gas";
    ApartmentUtilityType[ApartmentUtilityType["Water"] = 2] = "Water";
    ApartmentUtilityType[ApartmentUtilityType["Electricity"] = 3] = "Electricity";
    ApartmentUtilityType[ApartmentUtilityType["Heat"] = 4] = "Heat";
    ApartmentUtilityType[ApartmentUtilityType["TrashRemoval"] = 5] = "TrashRemoval";
    ApartmentUtilityType[ApartmentUtilityType["Sewer"] = 6] = "Sewer";
    ApartmentUtilityType[ApartmentUtilityType["Cable"] = 7] = "Cable";
    ApartmentUtilityType[ApartmentUtilityType["AirConditioning"] = 8] = "AirConditioning";
    ApartmentUtilityType[ApartmentUtilityType["Internet"] = 9] = "Internet";
})(ApartmentUtilityType || (ApartmentUtilityType = {}));
/** CoStar.Api.AptsListings.ViewModels.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["ApartmentCommunity"] = 1] = "ApartmentCommunity";
    ListingType[ListingType["ApartmentUnitForRent"] = 2] = "ApartmentUnitForRent";
    ListingType[ListingType["SingleFamilyHome"] = 3] = "SingleFamilyHome";
    /** @deprecated This value has been re-purposed for 'ResidentialCommunity'. */
    ListingType[ListingType["RoomForRent"] = 4] = "RoomForRent";
    ListingType[ListingType["ResidentialCommunity"] = 4] = "ResidentialCommunity";
    ListingType[ListingType["Townhome"] = 5] = "Townhome";
    ListingType[ListingType["CondoUnitForRent"] = 6] = "CondoUnitForRent";
    ListingType[ListingType["ResidentialUnitForRent"] = 7] = "ResidentialUnitForRent";
    ListingType[ListingType["Hospitality"] = 8] = "Hospitality";
})(ListingType || (ListingType = {}));
import { PetTolerance } from "../../../../CoStar/Api/EnterpriseSub2/Detail/ResidentialForRent/index.js";
/** CoStar.Api.AptsListings.ViewModels.PetTolerance */
export { PetTolerance };
/** CoStar.Api.AptsListings.ViewModels.ListingStatus */
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus[ListingStatus["Unknown"] = 0] = "Unknown";
    ListingStatus[ListingStatus["Active"] = 1] = "Active";
    ListingStatus[ListingStatus["Pending"] = 2] = "Pending";
    ListingStatus[ListingStatus["OffMarket"] = 3] = "OffMarket";
    ListingStatus[ListingStatus["Terminate"] = 4] = "Terminate";
    ListingStatus[ListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    ListingStatus[ListingStatus["Unpublished"] = 6] = "Unpublished";
    ListingStatus[ListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    ListingStatus[ListingStatus["UserDeleted"] = 8] = "UserDeleted";
    ListingStatus[ListingStatus["Upsell"] = 9] = "Upsell";
})(ListingStatus || (ListingStatus = {}));
/** CoStar.Api.AptsListings.ViewModels.PricingTools */
export var PricingTools;
(function (PricingTools) {
    PricingTools[PricingTools["None"] = 0] = "None";
    PricingTools[PricingTools["RentSpecial"] = 1] = "RentSpecial";
    PricingTools[PricingTools["BestValue"] = 2] = "BestValue";
    PricingTools[PricingTools["TopDeal"] = 4] = "TopDeal";
    PricingTools[PricingTools["Luxury"] = 8] = "Luxury";
    PricingTools[PricingTools["Cheap"] = 16] = "Cheap";
})(PricingTools || (PricingTools = {}));
/** CoStar.Api.AptsListings.ViewModels.RentInfoType */
export var RentInfoType;
(function (RentInfoType) {
    RentInfoType[RentInfoType["Term"] = 1] = "Term";
    RentInfoType[RentInfoType["MoveInDate"] = 2] = "MoveInDate";
})(RentInfoType || (RentInfoType = {}));
/** CoStar.Api.AptsListings.ViewModels.AvailabilityStatus */
export var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus[AvailabilityStatus["Unknown"] = 0] = "Unknown";
    AvailabilityStatus[AvailabilityStatus["Available"] = 1] = "Available";
    AvailabilityStatus[AvailabilityStatus["NotAvailable"] = 2] = "NotAvailable";
    AvailabilityStatus[AvailabilityStatus["AvailableSoon"] = 3] = "AvailableSoon";
})(AvailabilityStatus || (AvailabilityStatus = {}));
/** CoStar.Api.AptsListings.ViewModels.RentPricingType */
export var RentPricingType;
(function (RentPricingType) {
    RentPricingType[RentPricingType["Unknown"] = 0] = "Unknown";
    RentPricingType[RentPricingType["PerUnit"] = 1] = "PerUnit";
    RentPricingType[RentPricingType["PerBed"] = 2] = "PerBed";
    RentPricingType[RentPricingType["PerBedroom"] = 3] = "PerBedroom";
})(RentPricingType || (RentPricingType = {}));
/** CoStar.Api.AptsListings.ViewModels.StorageType */
export var StorageType;
(function (StorageType) {
    StorageType[StorageType["Unknown"] = 0] = "Unknown";
    StorageType[StorageType["BikeRack"] = 1] = "BikeRack";
    StorageType[StorageType["BikeStorage"] = 2] = "BikeStorage";
    StorageType[StorageType["StorageLocker"] = 3] = "StorageLocker";
    StorageType[StorageType["StorageUnit"] = 4] = "StorageUnit";
    StorageType[StorageType["SmallStorage"] = 5] = "SmallStorage";
    StorageType[StorageType["MediumStorage"] = 6] = "MediumStorage";
    StorageType[StorageType["LargeStorage"] = 7] = "LargeStorage";
    StorageType[StorageType["XLargeStorage"] = 8] = "XLargeStorage";
    StorageType[StorageType["XLargePlusStorage"] = 9] = "XLargePlusStorage";
    StorageType[StorageType["WineStorage"] = 10] = "WineStorage";
})(StorageType || (StorageType = {}));
import { LeedType } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsListings.ViewModels.LeedType */
export { LeedType };
/** CoStar.Api.AptsListings.ViewModels.ApartmentStyleType */
export var ApartmentStyleType;
(function (ApartmentStyleType) {
    ApartmentStyleType[ApartmentStyleType["None"] = 0] = "None";
    ApartmentStyleType[ApartmentStyleType["Garden"] = 1] = "Garden";
    ApartmentStyleType[ApartmentStyleType["MidRise"] = 2] = "MidRise";
    ApartmentStyleType[ApartmentStyleType["HighRise"] = 3] = "HighRise";
    ApartmentStyleType[ApartmentStyleType["LowRise"] = 4] = "LowRise";
    ApartmentStyleType[ApartmentStyleType["SingleFamilyHome"] = 5] = "SingleFamilyHome";
    ApartmentStyleType[ApartmentStyleType["Townhome"] = 6] = "Townhome";
})(ApartmentStyleType || (ApartmentStyleType = {}));
/** CoStar.Api.AptsListings.ViewModels.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["Cluster"] = 21] = "Cluster";
    /** @deprecated Use MatchType.Cluster (21) instead. */
    MatchType[MatchType["SubmarketCluster"] = 34] = "SubmarketCluster";
    MatchType[MatchType["MSA"] = 35] = "MSA";
})(MatchType || (MatchType = {}));
/** CoStar.Api.AptsListings.ViewModels.HomesMediaType */
export var HomesMediaType;
(function (HomesMediaType) {
    HomesMediaType[HomesMediaType["Unknown"] = 0] = "Unknown";
    HomesMediaType[HomesMediaType["Aerial"] = 1] = "Aerial";
    HomesMediaType[HomesMediaType["Financial"] = 2] = "Financial";
    HomesMediaType[HomesMediaType["PrimaryPhoto"] = 3] = "PrimaryPhoto";
    HomesMediaType[HomesMediaType["BuildingPhoto"] = 4] = "BuildingPhoto";
    HomesMediaType[HomesMediaType["VirtualTour"] = 5] = "VirtualTour";
    HomesMediaType[HomesMediaType["Lobby"] = 6] = "Lobby";
    HomesMediaType[HomesMediaType["Other"] = 7] = "Other";
    HomesMediaType[HomesMediaType["MarketingBrochure_Flyer"] = 8] = "MarketingBrochure_Flyer";
    HomesMediaType[HomesMediaType["PlatMap"] = 9] = "PlatMap";
    HomesMediaType[HomesMediaType["FloorPlan"] = 10] = "FloorPlan";
    HomesMediaType[HomesMediaType["SitePlan"] = 11] = "SitePlan";
    HomesMediaType[HomesMediaType["TypicalFloorPlan"] = 12] = "TypicalFloorPlan";
    HomesMediaType[HomesMediaType["Slate"] = 13] = "Slate";
    HomesMediaType[HomesMediaType["PrimaryContactPhoto"] = 14] = "PrimaryContactPhoto";
    HomesMediaType[HomesMediaType["Logo"] = 15] = "Logo";
    HomesMediaType[HomesMediaType["Map"] = 16] = "Map";
    HomesMediaType[HomesMediaType["_16x16png"] = 17] = "_16x16png";
    HomesMediaType[HomesMediaType["_24x24png"] = 18] = "_24x24png";
    HomesMediaType[HomesMediaType["TenantPhoto"] = 19] = "TenantPhoto";
    HomesMediaType[HomesMediaType["LeaseDocument"] = 20] = "LeaseDocument";
    HomesMediaType[HomesMediaType["PublicFiling"] = 21] = "PublicFiling";
    HomesMediaType[HomesMediaType["Deed"] = 22] = "Deed";
    HomesMediaType[HomesMediaType["TransferTaxDeclaration"] = 23] = "TransferTaxDeclaration";
    HomesMediaType[HomesMediaType["PropertyRecordCard"] = 24] = "PropertyRecordCard";
    HomesMediaType[HomesMediaType["AssignmentofRentsandLeases"] = 25] = "AssignmentofRentsandLeases";
    HomesMediaType[HomesMediaType["Loan"] = 26] = "Loan";
    HomesMediaType[HomesMediaType["Article"] = 27] = "Article";
    HomesMediaType[HomesMediaType["PressRelease"] = 28] = "PressRelease";
    HomesMediaType[HomesMediaType["SECFiling"] = 29] = "SECFiling";
    HomesMediaType[HomesMediaType["CompanyReport"] = 30] = "CompanyReport";
    HomesMediaType[HomesMediaType["MediaSource"] = 31] = "MediaSource";
    HomesMediaType[HomesMediaType["DirectoryPhoto"] = 32] = "DirectoryPhoto";
    HomesMediaType[HomesMediaType["InteriorPhoto"] = 33] = "InteriorPhoto";
    HomesMediaType[HomesMediaType["GoadMap"] = 34] = "GoadMap";
    HomesMediaType[HomesMediaType["CommunityBrochure"] = 35] = "CommunityBrochure";
    HomesMediaType[HomesMediaType["PlacardLogo"] = 36] = "PlacardLogo";
    HomesMediaType[HomesMediaType["PropertyLogo"] = 37] = "PropertyLogo";
    HomesMediaType[HomesMediaType["ConstructionPhoto"] = 38] = "ConstructionPhoto";
    HomesMediaType[HomesMediaType["ReinforcingAdvertisement"] = 39] = "ReinforcingAdvertisement";
    HomesMediaType[HomesMediaType["ProVideoApartments"] = 40] = "ProVideoApartments";
    HomesMediaType[HomesMediaType["CityPhoto"] = 41] = "CityPhoto";
    HomesMediaType[HomesMediaType["NeighborhoodPhoto"] = 42] = "NeighborhoodPhoto";
    HomesMediaType[HomesMediaType["ThreeDimensionalScan"] = 43] = "ThreeDimensionalScan";
    HomesMediaType[HomesMediaType["ProVideoApartmentFinder"] = 44] = "ProVideoApartmentFinder";
    HomesMediaType[HomesMediaType["ConfidentialityAgreement"] = 45] = "ConfidentialityAgreement";
    HomesMediaType[HomesMediaType["ProVideoApartamentos"] = 46] = "ProVideoApartamentos";
    HomesMediaType[HomesMediaType["CommercialListingVideo"] = 47] = "CommercialListingVideo";
    HomesMediaType[HomesMediaType["MarketingLogo"] = 48] = "MarketingLogo";
    HomesMediaType[HomesMediaType["ProVideoLoopNet"] = 49] = "ProVideoLoopNet";
    HomesMediaType[HomesMediaType["State"] = 50] = "State";
    HomesMediaType[HomesMediaType["County"] = 51] = "County";
    HomesMediaType[HomesMediaType["MilitaryBase"] = 52] = "MilitaryBase";
    HomesMediaType[HomesMediaType["College_University"] = 53] = "College_University";
    HomesMediaType[HomesMediaType["ArticleVideo"] = 54] = "ArticleVideo";
    HomesMediaType[HomesMediaType["AerialVideo"] = 55] = "AerialVideo";
    HomesMediaType[HomesMediaType["ThermalVideo"] = 56] = "ThermalVideo";
    HomesMediaType[HomesMediaType["UAVVideo"] = 57] = "UAVVideo";
    HomesMediaType[HomesMediaType["ProVideoForRent"] = 58] = "ProVideoForRent";
    HomesMediaType[HomesMediaType["PlacardPrimaryPhoto"] = 59] = "PlacardPrimaryPhoto";
    HomesMediaType[HomesMediaType["ShortUAVVideo"] = 60] = "ShortUAVVideo";
    HomesMediaType[HomesMediaType["PlacardLogo_Vector"] = 61] = "PlacardLogo_Vector";
    HomesMediaType[HomesMediaType["CoStarPlaneView"] = 62] = "CoStarPlaneView";
    HomesMediaType[HomesMediaType["DesktopCoverPhotoResidential"] = 63] = "DesktopCoverPhotoResidential";
    HomesMediaType[HomesMediaType["PlacardHighlightPhoto"] = 64] = "PlacardHighlightPhoto";
    HomesMediaType[HomesMediaType["PlacardHighlightVideo"] = 65] = "PlacardHighlightVideo";
    HomesMediaType[HomesMediaType["AmenityPhoto"] = 66] = "AmenityPhoto";
    HomesMediaType[HomesMediaType["AmenityVideo"] = 67] = "AmenityVideo";
    HomesMediaType[HomesMediaType["MobileCoverPhotoResidential"] = 68] = "MobileCoverPhotoResidential";
    HomesMediaType[HomesMediaType["DesktopCoverPhotoCommercial"] = 69] = "DesktopCoverPhotoCommercial";
    HomesMediaType[HomesMediaType["MobileCoverPhotoCommercial"] = 70] = "MobileCoverPhotoCommercial";
    HomesMediaType[HomesMediaType["LandRegistry"] = 71] = "LandRegistry";
    HomesMediaType[HomesMediaType["CollegeLogo"] = 72] = "CollegeLogo";
    HomesMediaType[HomesMediaType["TenantExternalPhoto"] = 73] = "TenantExternalPhoto";
    HomesMediaType[HomesMediaType["TenantInternalPhoto"] = 74] = "TenantInternalPhoto";
    HomesMediaType[HomesMediaType["PylonPhoto"] = 75] = "PylonPhoto";
    HomesMediaType[HomesMediaType["StockPhoto"] = 76] = "StockPhoto";
    HomesMediaType[HomesMediaType["CoverPagePhoto"] = 77] = "CoverPagePhoto";
    HomesMediaType[HomesMediaType["SpaceManagerPhoto"] = 78] = "SpaceManagerPhoto";
    HomesMediaType[HomesMediaType["ResidentialListingVideo"] = 79] = "ResidentialListingVideo";
    HomesMediaType[HomesMediaType["OfferingMemorandum"] = 80] = "OfferingMemorandum";
    HomesMediaType[HomesMediaType["BrandExteriorPhoto"] = 81] = "BrandExteriorPhoto";
    HomesMediaType[HomesMediaType["BrandInteriorPhoto"] = 82] = "BrandInteriorPhoto";
    HomesMediaType[HomesMediaType["NeighborhoodVideo"] = 83] = "NeighborhoodVideo";
    HomesMediaType[HomesMediaType["NeighborhoodVideoClip"] = 84] = "NeighborhoodVideoClip";
    HomesMediaType[HomesMediaType["ParkVideo"] = 85] = "ParkVideo";
    HomesMediaType[HomesMediaType["ParkVideoClip"] = 86] = "ParkVideoClip";
    HomesMediaType[HomesMediaType["SchoolVideo"] = 87] = "SchoolVideo";
    HomesMediaType[HomesMediaType["SchoolVideoClip"] = 88] = "SchoolVideoClip";
    HomesMediaType[HomesMediaType["CondoBuildingVideo"] = 89] = "CondoBuildingVideo";
    HomesMediaType[HomesMediaType["CondoBuildingVideoClip"] = 90] = "CondoBuildingVideoClip";
    HomesMediaType[HomesMediaType["VideoProjectFile"] = 91] = "VideoProjectFile";
    HomesMediaType[HomesMediaType["AudioFile"] = 92] = "AudioFile";
    HomesMediaType[HomesMediaType["ProductionScript"] = 93] = "ProductionScript";
    HomesMediaType[HomesMediaType["ParkPhoto"] = 94] = "ParkPhoto";
    HomesMediaType[HomesMediaType["SchoolPhoto"] = 95] = "SchoolPhoto";
    HomesMediaType[HomesMediaType["CaseDocument"] = 96] = "CaseDocument";
    HomesMediaType[HomesMediaType["ViewFromUnit"] = 97] = "ViewFromUnit";
    HomesMediaType[HomesMediaType["AgentVideo"] = 98] = "AgentVideo";
    HomesMediaType[HomesMediaType["AgentVideoClip"] = 99] = "AgentVideoClip";
    HomesMediaType[HomesMediaType["StockVideo"] = 100] = "StockVideo";
    /** @deprecated This will go away soon. Use StreetView instead. */
    HomesMediaType[HomesMediaType["OldStreetView"] = 101] = "OldStreetView";
    /** @deprecated This will go away soon. Use StaticMap instead. */
    HomesMediaType[HomesMediaType["OldStaticMap"] = 102] = "OldStaticMap";
    /** @deprecated This will go away soon. Use ParcelMap instead. */
    HomesMediaType[HomesMediaType["OldParcelMap"] = 103] = "OldParcelMap";
    HomesMediaType[HomesMediaType["StreetView"] = 100001] = "StreetView";
    HomesMediaType[HomesMediaType["StaticMap"] = 100002] = "StaticMap";
    HomesMediaType[HomesMediaType["ParcelMap"] = 100003] = "ParcelMap";
})(HomesMediaType || (HomesMediaType = {}));
/** CoStar.Api.AptsListings.ViewModels.ListingLiteMatchType */
export var ListingLiteMatchType;
(function (ListingLiteMatchType) {
    ListingLiteMatchType[ListingLiteMatchType["Unknown"] = 0] = "Unknown";
    ListingLiteMatchType[ListingLiteMatchType["MatchByListingId"] = 1] = "MatchByListingId";
    ListingLiteMatchType[ListingLiteMatchType["MatchByPropertyId"] = 2] = "MatchByPropertyId";
    ListingLiteMatchType[ListingLiteMatchType["MatchByPropertyResidentialId"] = 3] = "MatchByPropertyResidentialId";
    ListingLiteMatchType[ListingLiteMatchType["MatchByApartmentUnitId"] = 4] = "MatchByApartmentUnitId";
})(ListingLiteMatchType || (ListingLiteMatchType = {}));
import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.AptsListings.ViewModels.CurrencyType */
export { CurrencyType };
